<div class="container">
  <h1 class="title">Complete los datos faltantes</h1>
  <form class="form" [formGroup]="formGroup">
    <mat-form-field *ngIf="formGroup.controls.phone" class="second" appearance="outline">
      <mat-label>Número de teléfono</mat-label>
      <input
        matInput
        mask="0000000000"
        type="text"
        formControlName="phone"
        placeholder="Teléfono"
      />
      <mat-error
        *ngIf="
          (!formGroup.controls.phone.pristine || formGroup.controls.phone.touched) &&
          formGroup.controls.phone.invalid
        "
      >
        {{ getErrorMessage('phone') }}
      </mat-error>
    </mat-form-field>
    <button
      mat-button
      class="td-btn primary"
      [disabled]="formGroup.invalid"
      (click)="updateUserInfo()"
    >
      Confirmar
    </button>
  </form>
</div>
